/**
 * How a beneficiary's results card trims a full standings list (namat#36),
 * shared with namat-mobile's CompetitionsWidget: the top N rows, and — when
 * the viewer is not among them — the viewer's own row after a «···» gap.
 */

/** Rows shown per standings tab. Mobile asks getCompetitionStandings for 5. */
export const COMPETITION_TOP_N = 5;

export interface TopSlice<T> {
  top: T[];
  /** The viewer's row when it falls outside `top`; null when inside or absent. */
  me: T | null;
}

export function sliceTopWithMe<T>(rows: T[], isMe: (row: T) => boolean, n: number = COMPETITION_TOP_N): TopSlice<T> {
  const top = rows.slice(0, Math.max(0, n));
  if (top.some(isMe)) return { top, me: null };
  return { top, me: rows.find(isMe) ?? null };
}

/**
 * «1 Oct – 30 Oct»: short month and day, Gregorian with Western digits in
 * both languages (plain `ar` may pick Arabic-Indic digits).
 */
export function formatCompetitionDateRange(start: Date, end: Date, language: string): string {
  const locale = language === 'ar' ? 'ar-u-ca-gregory-nu-latn' : 'en';
  const fmt = (d: Date) => {
    try {
      return d.toLocaleDateString(locale, { month: 'short', day: 'numeric' });
    } catch {
      return '';
    }
  };
  return `${fmt(start)} – ${fmt(end)}`;
}

/** «x/y» for the today's-habits card: personal and competition habits together. */
export function habitsDoneCount(done: boolean[]): { done: number; total: number } {
  return { done: done.filter(Boolean).length, total: done.length };
}
